export default "__VITE_ASSET__DCCjMsxi__"